import styled, { css } from 'styled-components';

import { Button } from '@xing-com/button';
import type { ButtonSizes } from '@xing-com/button';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';

type ButtonSmallWhenTopBarProps = {
  $size: ButtonSizes;
};

export const ButtonSmallWhenTopBar = styled(Button)<ButtonSmallWhenTopBarProps>`
  ${({ $size }) => {
    if ($size === 'small') {
      return css`
        /* stylelint-disable-next-line media-query-no-invalid */
        @media ${mediaTopBarHidden} {
          display: none;
        }
      `;
    }

    return css`
      /* stylelint-disable-next-line media-query-no-invalid */
      @media ${mediaTopBarVisible} {
        display: none;
      }
    `;
  }}
`;
